import BigNumber from 'bignumber.js';
import { useMemo, useState } from 'react';
import { useTradeStore } from '../store';
import { useBscTokenAllowance } from '@boomeme/wallet-sdk';

export const useBscApprove = () => {
  const { tokenInfo, chainTokenAmount } = useTradeStore();

  const tokenType = useMemo(() => (tokenInfo?.dexType === 1 ? (tokenInfo.isCompleted ? 'pancake' : 'fourmeme') : 'pancake'), [tokenInfo]);
  const { approve, allowance, fetchAllowance } = useBscTokenAllowance(tokenInfo?.address, tokenType);

  const [approveLoading, setApproveLoading] = useState(false);
  const needApproval = useMemo(() => {
    return BigNumber(chainTokenAmount)
      .times(10 ** (tokenInfo?.decimals as number))
      .gt(allowance.toString());
  }, [chainTokenAmount, allowance, tokenInfo?.decimals]);

  const bscApproveToken = async () => {
    if (!needApproval) return;
    try {
      setApproveLoading(true);
      const res = await approve();
      if (res) {
        setApproveLoading(false);
        fetchAllowance();
      }
    } catch (error) {
      throw error;
    } finally {
      setApproveLoading(false);
    }
  };

  return {
    needApproval,
    approveLoading,
    bscApproveToken,
  };
};
